import ShippingOptionsCustomerTable, {
  CrmReceiverCustomer,
} from '../ShippingOptionsCustomerTable';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import CrmCustomerListFilter, {
  CrmFilterFormValues,
} from '../CustomerListFilter';
import { Button, Col, Divider, Row } from 'antd';
import AntdFeatherIcon from '@/components/_common/AntdFeatherIcon';
import { ArrowLeft, ArrowRight } from 'react-feather';
import { FormattedMessage } from 'react-intl';
import { useState } from 'react';
import { DateTimeFormat } from '@/utils/moment';
import { CrmCustomerListProps } from '@/core/domain/crm/CrmList/CrmList.types';
import { useCrmCustomerFutureServiceList } from '@/core/domain/crm/CrmList/CrmList.hooks';
import { useWindowSize } from '@/hooks';

const CrmCustomersList: React.FC<CrmCustomerListProps> = ({
  onPrev,
  onCustomersSelected,
  customerIds,
  CustomersSelected,
}) => {
  const [filter, setFilter] = useState<CrmFilterFormValues>();
  const { isMobile } = useWindowSize();

  const queryReturn = useCrmCustomerFutureServiceList({
    ...filter,
    initialDate: filter?.initialDate
      ? filter?.initialDate?.format(DateTimeFormat)
      : undefined,
    finalDate: filter?.finalDate
      ? filter?.finalDate?.format(DateTimeFormat)
      : undefined,
  });

  const items = flatInfiniteData(queryReturn?.data);

  const dataSource = items.map<CrmReceiverCustomer>(
    ({ customer, futureServices, ...item }) => ({
      id: item.vehicleId,
      customer,
      futureServices,
      vehicle: { ...item, id: item.vehicleId },
    }),
  );

  return (
    <>
      <CrmCustomerListFilter onFilter={setFilter} />

      <Divider />

      <ShippingOptionsCustomerTable
        dataSource={dataSource}
        loading={queryReturn?.isLoading}
        onCustomersSelected={onCustomersSelected}
        CustomersSelected={CustomersSelected}
        customerIds={customerIds}
        refetch={queryReturn?.refetch}
        fetchNextPage={queryReturn?.fetchNextPage}
        hasNextPage={queryReturn?.hasNextPage}
        isFetching={queryReturn?.isFetching}
      />

      <Row gutter={[24, 24]} style={{ marginTop: 24 }} justify="end">
        <Col span={isMobile ? 24 : undefined}>
          <Button onClick={onPrev} block>
            <AntdFeatherIcon icon={<ArrowLeft />} size={12} />
            <FormattedMessage id="commons.modal.button.back" />
          </Button>
        </Col>

        <Col span={isMobile ? 24 : undefined}>
          <Button htmlType="submit" block>
            <AntdFeatherIcon icon={<ArrowRight />} size={12} />
            <span>Continuar</span>
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default CrmCustomersList;
